import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { PIN_SIZE, TIMELINE_STATUS } from './constants';
import { getPinStyles } from './utils';
const mapStatusIcon = {
    [TIMELINE_STATUS.CURRENT]: null,
    [TIMELINE_STATUS.DONE]: 'check',
    [TIMELINE_STATUS.ERROR]: 'circle-exclamation',
    [TIMELINE_STATUS.PENDING]: 'clock',
    [TIMELINE_STATUS.DEFAULT]: null,
};
export const Pin = ({ direction = 'vertical', status }) => {
    const statusIcon = mapStatusIcon[status];
    return (_jsx(PinWrap, { "$direction": direction, "$status": status, children: statusIcon && (_jsx(Box, { alignItems: "center", height: `${PIN_SIZE}px`, justifyContent: "center", width: `${PIN_SIZE}px`, children: _jsx(FontAwesomeIcon, { color: "white", height: "10px", iconName: statusIcon, iconType: CATEGORIES.SOLID }) })) }));
};
const PinWrap = styled(Box) `
  color: #fff;
  position: absolute;
  left: 0;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  width: ${PIN_SIZE}px;
  height: ${PIN_SIZE}px;
  border-radius: ${PIN_SIZE}px;
  ${getPinStyles}

  ${({ $direction }) => $direction === 'horizontal' &&
    `
      transform: translateX(-50%);
      left: 50%;
      top: 0;
  `}
`;
//# sourceMappingURL=Pin.js.map